import { createContext, useContext } from "react";

/**
 * MeetingContext - the in-meeting app's starting point: Zoom context, availability, the RTMS session
 * already running when the app opened, and the resolved meeting mode.
 *
 * Provided by InMeeting once initialization finishes. Flow UIs (Home / Hire) read it with useMeeting().
 */
const MeetingContext = createContext(null);

export const useMeeting = () => useContext(MeetingContext);

export const MeetingProvider = ({ value, children }) => (
  <MeetingContext.Provider value={value}>{children}</MeetingContext.Provider>
);
